<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>

<script>
  import echarts from "echarts";
  import store from "@/store";
  import { onMounted, reactive, ref, toRefs, watch } from "vue";
  export default {
    name: "indexEcharts",
    props: {
      echartsData: {
        type: Object
      },
      panel: {
        type: Object
      }
    },
    setup(props) {
      const charts = ref();
      const state = reactive({
        info: store.state.user.info,
      })
      var myChart;
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          myChart = echarts.init(chart);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });

      });
      const option = ref({
        title: {
          text: '',
          left: 30,
          top: 20,
          textStyle: {
            fontFamily: '幼圆',
            lineHeight: 20,
            rich: {
              a: {
                color: '#FFF',
                fontSize: '12',
                height: 15,
                width: 15,
                backgroundColor: {
                  image: require('@/assets/images/jianpan.png')
                }
              },
            }
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {               //设置区分（哪条线属于什么）
          data: ['新增用户'],
          top: '5%',
        },
        xAxis: {
          type: "category",
          data: ["2021-02-25", "2021-02-26", "2021-02-27", "2021-02-28", "2021-03-01", "2021-03-02", "2021-03-03"]
        },
        grid: {
          x: '5%', //相当于距离左边效果:padding-left
          y: '15%',  //相当于距离上边效果:padding-top
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: {
          name: '新增用户',
          data: [100, 400, 40, 231, 1500, 78, 190],
          type: 'line',
          smooth: true
        },
      });
      watch(props, () => {
        option.value.title.text = props.panel.name
        option.value.xAxis.data = props.echartsData.date
        option.value.series.data = props.echartsData.counts
        option.value.series.name = props.panel.name
        option.value.legend.data = [props.panel.name]
        myChart.setOption(option.value);
      })

      return {
        charts,
        ...toRefs(state)
      };
    },
  };
</script>